// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Video-module--wrapper--2sXQb","title":"Video-module--title--13pRI","video":"Video-module--video--1Xe3S"};